import { clearAuthStorage } from "auth/authStorage";

export const ErrorHandler = (error) => {
  if (error.response) {
    if (error.response.status === 401) {
      clearAuthStorage();
      window.location.href = "/login";
    }
    return error.response.data?.message || "Unexpected server error";
  } else if (error.request) {
    
    // return "Session timeout, please refresh the page";
  } else {
    
    // return "Something went wrong. Please try again.";
  }
};
